/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RecentlyVisitedPost$Params {
  PatientId?: string | null;
  PatientName?: string | null;
  PracticeId?: string | null;
  UserId?: number;
  CreatedBy?: number;
  ModifiedBy?: number;
  VisitDate?: string;
  Createtimestamp?: string;
  Modifytimestamp?: string;
}

export function recentlyVisitedPost(http: HttpClient, rootUrl: string, params?: RecentlyVisitedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, recentlyVisitedPost.PATH, 'post');
  if (params) {
    rb.query('PatientId', params.PatientId, {});
    rb.query('PatientName', params.PatientName, {});
    rb.query('PracticeId', params.PracticeId, {});
    rb.query('UserId', params.UserId, {});
    rb.query('CreatedBy', params.CreatedBy, {});
    rb.query('ModifiedBy', params.ModifiedBy, {});
    rb.query('VisitDate', params.VisitDate, {});
    rb.query('Createtimestamp', params.Createtimestamp, {});
    rb.query('Modifytimestamp', params.Modifytimestamp, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

recentlyVisitedPost.PATH = '/addRecentlyVisitedPatientRecords';
